/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./battleTest.vue?vue&type=template&id=78bbd9b6&scoped=true"
import script from "./battleTest.vue?vue&type=script&lang=js"
export * from "./battleTest.vue?vue&type=script&lang=js"
import style0 from "./battleTest.vue?vue&type=style&index=0&id=78bbd9b6&prod&lang=css"
import style1 from "./battleTest.vue?vue&type=style&index=1&id=78bbd9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bbd9b6",
  null
  
)

export default component.exports